<template>
  <div class="HeadComponents">
    <div class="head-left">
      <img class="logo" src="../assets/imgs/top_logo.png" alt="">
      <div class="nav">
        <div class="nav-item cs" @click="jump('transaction')"
          :class="this.$route.path == '/transaction' ? 'nav-active' : ''"> {{ $t('trade.text19') }}
        </div>
        <div class="nav-item cs" @click="jump('transactionMn')"
          :class="this.$route.path.indexOf('/transactionMn') != -1 ? 'nav-active' : ''"> {{ $t('trade.text156') }}
        </div>
        <div class="nav-item cs" @click="jump('download')"
          :class="this.$route.path.indexOf('/download') != -1 ? 'nav-active' : ''"> {{ $t('myAccount.text179') }}
        </div>
      </div>
    </div>
    <div class="head-right">
      <div class="set">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link cs">
            <i class="iconfont icon-xzjh"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu :style="{ width: lang == 'cn' ? '150px' : '220px' }">
              <ul class="set_ul">
                <li>
                  <h2 class="set_ul_h2">{{ $t('trade.text168') }}</h2>
                  <el-radio-group v-model="upColor" class="ml-4" @change="onChange">
                    <el-radio value="red">
                      <span class="text_red">{{ $t('trade.text169') }}</span>
                      <span class="text_green">{{ $t('trade.text170') }}</span></el-radio>
                    <el-radio value="green">
                      <span class="text_green">{{ $t('trade.text171') }}</span>
                      <span class="text_red">{{ $t('trade.text172') }}</span></el-radio>
                    <el-radio value="blue">
                      <span class="text_blue">{{ $t('trade.text173') }}</span>
                      <span class="text_red">{{ $t('trade.text172') }}</span></el-radio>
                  </el-radio-group>
                </li>
                <div class="line"></div>
                <li>
                  <h2 class="set_ul_h2_2">{{ $t('trade.text174') }}</h2>
                  <el-radio-group v-model="instantTrading" class="ml-4" @change="instantTradingFunc">
                    <el-radio v-model="instantTrading" value="1"><span>{{ $t('trade.text175') }}</span></el-radio>
                    <el-radio v-model="instantTrading" value="2"><span>{{ $t('trade.text176') }}</span></el-radio>
                  </el-radio-group>
                </li>
              </ul>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>


      <div class="hr"></div>
      <div class="user">
        <el-dropdown>
          <span class="el-dropdown-link cs">
            <div class="user-box">
              <img :src="headpicUrl" alt="User Avatar" v-if="headpicUrl" />
              <div class="name">{{ accountName || 'User' }}</div>
              <i class="iconfont icon-more_gray"></i>
            </div>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-if="!isAccountInfoPage" @click="jump('myAccount')"><i class="iconfont icon-web"></i>{{
                $t('proxy.text111') }}</el-dropdown-item>
              <el-dropdown-item v-if="isTrader" @click="jumpIfAuthorized('followorder', isTrader)"><i
                  class="iconfont icon-daili"></i>{{ $t('proxy.text280') }}</el-dropdown-item>
              <el-dropdown-item v-if="isProxyAdmin" @click="jumpIfAuthorized('agent', isProxyAdmin)"><i
                  class="iconfont icon-daili"></i>{{ $t('proxy.text195') }}</el-dropdown-item>
              <el-dropdown-item @click="handleLogout()"><i class="iconfont icon-out"></i>{{
                $t('proxy.text256') }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="hr"></div>

      <!-- 服务器选择模块 -->
      <div v-if=currentServer?.name class="server-selector">
        <el-dropdown>
          <span class="el-dropdown-link cs">
            <div class="server-box">
              <span>{{ currentServer?.name }}</span>
              <i class="iconfont icon-more_gray"></i>
            </div>
          </span>
          <template #dropdown>
            <el-dropdown-menu class="server-dropdown">
              <el-radio-group v-model="selectedServerName" @change="changeServer">
                <el-dropdown-item v-for="server in serverList" :key="server.name">
                  <div class="server-radio-content">
                    <el-radio :value="server.name">

                      <div class="server-name-wrapper">
                        <span class="server-name">{{ server.name }}</span>
                      </div>
                    </el-radio>
                    <div class="server-latency">
                      {{ server.latency || "..." }} ms
                    </div>
                  </div>
                </el-dropdown-item>
              </el-radio-group>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div v-if=currentServer?.name class="hr"></div>
      <div class="lang">
        <el-dropdown>
          <span class="el-dropdown-link cs">
            <div class="lang-box">
              <span>{{ lang == 'cn' ? '简体中文' : 'English' }}</span>
              <i class="iconfont icon-more_gray"></i>
            </div>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="ChangeLang('cn')">简体中文</el-dropdown-item>
              <el-dropdown-item @click="ChangeLang('en')">English</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" :title="$t('trade.text167')" width="700" class="my_dialog" :show-close="false">
      <div class="scroll">
        <p>
          {{ $t('trade.text157') }}
        </p>
        <p>
          <span class="circle"></span>{{ $t('trade.text158') }}
        </p>
        <p>
          <span class="circle"></span>{{ $t('trade.text159') }}
        </p>
        <p>
          {{ $t('trade.text160') }}
        </p>
        <p>
          {{ $t('trade.text161') }}
        </p>
        <p>
          {{ $t('trade.text162') }}
        </p>
        <p>
          {{ $t('trade.text163') }}
        </p>
      </div>

      <div>
        <span class="my_radio" :class="agreeFlag ? 'agree' : ''" @click="agreeFlag = !agreeFlag"></span>{{
          $t('trade.text166') }}
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ $t('trade.text72') }}</el-button>
          <el-button type="primary" @click="openInstantTradingFunc" :disabled="!agreeFlag">
            {{ $t('trade.text73') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import apiServer from "@/api/request"; // Import API request method
import { setSelectedServer, getSelectedServer, loadCachedServerList } from '@/api/http';
import { getQueryVariable } from '@/until/common';

export default {
  name: 'HeadComponents',
  props: {},
  computed: {
    isAccountInfoPage() {
      // 获取当前路由的路径
      return this.$route.path.includes('accountInformation');
    }
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { t } = useI18n();
    const { locale } = useI18n();
    const store = useStore();

    const lang = computed({ get: () => store.getters.getNowTheme.lang });
    const upColor = ref("red");
    const instantTrading = ref("2");
    const dialogVisible = ref(false);
    const agreeFlag = ref(false);
    const accountName = computed({ get: () => store.getters.userInfo.nickname });
    const isTrader = ref(false);
    const isProxyAdmin = ref(false);
    const headpicUrl = computed({ get: () => store.getters.userInfo.headpicUrl });
    const serverList = ref([]); // 服务器列表
    const selectedServerName = ref(""); // 当前选中服务器的名字
    const currentServer = ref({}); // 当前选中服务器

    // 获取用户信息
    const fetchUserInfo = async () => {
      try {
        const response = await apiServer.UserInformation();
        if (response.status === 1) {
          console.log("route.path", route.path, route.path === '/')
          if (route.path === '/') {
            // 如果用户中心无权限 且不是代理系统管理员 且不是跟单系统管理员，弹出暂无权限提示
            if (!response.data.hasCrmPermission && !(response.data.hasProxyPermission && response.data.isProxyAdmin) && !(response.data.hasTraderPermission && response.data.isTrader)) {
              router.push({
                name: 'login'
              });
              return;
            }


            if (!response.data.hasCrmPermission) {
              if (response.data.hasProxyPermission && response.data.isProxyAdmin) {
                router.push({
                  name: 'agentDashboard'
                });
              } else if (response.data.hasTraderPermission && response.data.isTrader) {
                router.push({
                  name: 'followorderaccount'
                });
              }
              return;
            }
            router.push({
              name: 'myAccount'
            });
          }

          const { isProxyAdmin: proxy, isTrader: trader, nickname, headpicUrl: avatar, hasProxyPermission: proxyPermission, hasTraderPermission: traderPermission } = response.data;
          isProxyAdmin.value = proxy && proxyPermission;
          isTrader.value = trader && traderPermission;
          // accountName.value = nickname || 'User';
          // headpicUrl.value = avatar || ''; // 头像 URL



        } else {
          ElMessage.error("Failed to fetch user info.");
        }
      } catch (error) {
        console.error("User Information Fetch Error:", error);
      }
    };

    onMounted(() => {
      upColor.value = store.state.home.contentColor;
      instantTrading.value = localStorage.instantTrading || "2";

      // 获取服务器信息
      loadServersFromCache();

    

      // 如果未登录，跳转到登录页
      if (localStorage.userToken) {
        fetchUserInfo();
      }
    });

    // 切换服务器
    const changeServer = (selectedName) => {
      const selectedServer = serverList.value.find((server) => server.name === selectedName);
      if (selectedServer) {
        currentServer.value = selectedServer;
        selectedServerName.value = selectedName;
        setSelectedServer(selectedServer);
      }
    };

    // 获取服务器列表
    const loadServersFromCache = async () => {
      const storedServer = await getSelectedServer();
      serverList.value = await loadCachedServerList();
      if (!storedServer || !storedServer.name) {
        // 如果没有选中的服务器，则设置默认服务器为第一个
        const defaultServer = serverList.value[0];
        currentServer.value = defaultServer;
        selectedServerName.value = defaultServer.name;
        setSelectedServer(defaultServer);
      } else {
        currentServer.value = storedServer;
        selectedServerName.value = storedServer.name;
      }
    };

    // 跳转带权限判断
    const jumpIfAuthorized = (routeName, isAuthorized) => {
      if (isAuthorized) {
        router.push({ name: routeName });
      } else {
        ElMessage.warning("Unauthorized Access");
      }
    };

    // 跳转无权限判断
    const jump = (e) => {
      if (e == "transactionMn") {
        apiServer.SwitchQuoteInfo().then((res) => {
          console.log("SwitchQuoteInfo", res);
          let status = res.data.demo.status;
          if (status == 0) {
            router.push({
              name: "signUp",
            });
          } else if (status == 2 || status == 3) {
            ElMessage({
              message: t("trade.text148"),
              type: "error",
            });
            return;
          } else {
            router.push({
              name: e,
            });
          }
        });
      } else {
        router.push({
          name: e,
        });
      }
    };

    // 切换语言
    const ChangeLang = (newLang) => {
      locale.value = newLang;
      store.commit('NOW_LANG', newLang);
      localStorage.setItem('lang', newLang);
      window.location.reload();
    };

    // 快速交易切换
    const instantTradingFunc = (e) => {
      if (!localStorage.userToken) {
        router.push("/login");
        instantTrading.value = "2";
      } else {
        if (e == "1") {
          instantTrading.value = "2";
          dialogVisible.value = true;
        } else {
          localStorage.instantTrading = e;
          agreeFlag.value = false;
        }
      }
    };

    // 确认快速交易
    const openInstantTradingFunc = () => {
      if (agreeFlag.value) {
        instantTrading.value = "1";
        localStorage.instantTrading = "1";
      }
      dialogVisible.value = false;
      ElMessage({
        message: t("trade.text150"),
        type: "success",
      });
    };

    // 涨跌色切换
    const onChange = (e, f) => {
      localStorage.removeItem("tradingview.chartproperties.mainSeriesProperties"); //移除用户设置颜色
      store.commit("NOW_UP_COLOR", e);
      document.body.className = ""; // 清空之前的class
      document.body.classList.add(`${e}-up`);
      if (!f) {
        location.reload();
      }
    };

    // 处理登出
    const handleLogout = () => {
      apiServer.Logout().then((response) => {
        if (response.status === 1) {
          localStorage.clear();
          localStorage.setItem('lang', locale.value);
          store.commit('NOW_LANG', locale.value);
          router.push('/login');
        } else {
          console.error('登出失败:', response.message);
        }
      }).catch((error) => {
        console.error('登出请求错误:', error);
      });
    };

    return {
      lang,
      upColor,
      instantTrading,
      dialogVisible,
      agreeFlag,
      accountName,
      isTrader,
      isProxyAdmin,
      headpicUrl,
      jump,
      jumpIfAuthorized,
      ChangeLang,
      onChange,
      instantTradingFunc,
      openInstantTradingFunc,
      handleLogout,
      changeServer,
      serverList,
      selectedServerName,
      currentServer,
    };
  }
};
</script>

<style lang="less" scoped>
.HeadComponents {
  height: 64px;
  background: #1F2935;
  padding-left: 48px;
  display: flex;
  justify-content: space-between;
  padding-right: 100px;

  .my_dialog {
    .scroll {
      max-height: 450px;
      overflow-y: scroll;
    }

    p {
      margin-bottom: 16px;
      font-size: 14px;
    }

    .circle {
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #666d7f;
      border-radius: 50%;
      margin-right: 6px;
    }

    .my_radio {
      width: 12px;
      height: 12px;
      display: inline-block;
      border: 1px solid #bdbdbd;
      border-radius: 50%;
      margin-right: 8px;
      position: relative;
      top: 1px;
      cursor: pointer;
      margin-top: 10px;
    }

    .my_radio.agree {
      background: url(https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/selectrmal.png) no-repeat;
      background-size: 100% 100%;
      border: 0;
    }
  }

  .head-left {
    display: flex;
    justify-content: left;
    align-items: center;

    .logo {
      display: block;
      width: 125px;
      height: 32px;
    }

    .nav {
      margin-left: 50px;
      display: flex;

      .nav-item {
        color: #CFD3DD;
        margin-right: 40px;
      }

      .nav-active {
        color: #51B4F1;
      }
    }
  }

  .head-right {
    display: flex;
    justify-content: left;
    align-items: center;

    .set {
      display: flex;
      float: right;
      align-items: center;
      height: 30px;
      margin-right: 13px;

      .icon-xzjh {
        color: white;
        font-size: 20px;
      }

      img {
        width: 24px;
        height: 24px;
      }
    }

    .hr {
      height: 16px;
      width: 1px;
      background: rgba(255, 255, 255, 0.3);
      margin: 0 20px;
    }

    .user {
      .user-box {
        font-size: 14px;
        display: flex;
        justify-content: left;
        color: #FFFFFF;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }

        .name {
          margin-left: 8px;
          margin-right: 6px;
        }

        .icon-more_gray {
          font-size: 10px;
          color: #979797;
        }
      }
    }

    .lang {
      .lang-box {
        display: flex;
        justify-content: left;
        align-items: center;
        height: 24px;

        span {
          color: #CFD3DD;
          font-size: 14px;
        }

        .icon-more_gray {
          font-size: 10px;
          margin-left: 6px;
          color: #979797;
        }
      }
    }
  }


  .el-dropdown-link {
    display: flex;
    align-items: center;
    color: #51B4F1;
    border-radius: 4px;
    padding: 4px 8px;
  }

  .my_radio {
    width: 12px;
    height: 12px;
    display: inline-block;
    border: 1px solid #bdbdbd;
    border-radius: 50%;
    margin-right: 8px;
    position: relative;
    top: 1px;
    cursor: pointer;
    margin-top: 10px;
  }

  .my_radio.agree {
    background: url(https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/selectormal.png) no-repeat;
    background-size: 100% 100%;
    border: 0;
  }
}
</style>

<style lang="less">
.set_ul {
  padding: 10px 20px;

  .set_ul_h2 {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .set_ul_h2_2 {
    font-size: 14px;
    margin-bottom: 8px;
    margin-top: 8px;
  }

  .iconfont {
    font-size: 8px;
    color: #51B4F1;
  }
}

.text_blue {
  color: #1E90FF;
}

.text_green {
  color: #32CD32;
}

.text_red {
  color: #FF6347;
}

.server-selector {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 30px;

  .server-box {
    display: flex;
    justify-content: left;
    align-items: center;
    height: 24px;

    span {
      color: #CFD3DD;
      font-size: 14px;
    }

    .icon-more_gray {
      font-size: 10px;
      margin-left: 6px;
      color: #979797;
    }
  }
}

.server-dropdown {
  max-width: 120px !important;
  /* 设置最大宽度 */
  width: auto;
  /* 自动调整宽度 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 超出显示省略号 */
  white-space: nowrap;
  /* 不换行 */

  .server-radio-content {

    .server-name {
      flex: 1;
      font-size: 14px;
    }

    .server-latency {
      margin-left: 24px;
      font-size: 12px;
      color: #666;
    }

    .server-latency.timeout {
      color: red;
    }
  }
}

.server-radio-content {
  display: flex;
  flex-direction: column;
  /* 垂直布局 */
}

.server-name-wrapper {
  display: flex;
  align-items: center;
  /* el-radio 和第一行文本垂直居中对齐 */
}
</style>